import {IEnvironment} from './ienvironment';

export const environment: IEnvironment = {
  demeterApi: 'https://staging-demeter.planted-labs.com',
  production: false,
  rootApp: 'https://root.planted-labs.com',
  crashPAD: 'https://crashpad.planted-labs.com',
  key: 'plttk'
};
